/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_SAL_PERIODS_ITEM = {
  id: 'periods_sidebar',
  screenId: 'lab-sal-periods',
  label: 'Periodos',
  description: 'Ventanas de fechas para agrupar salarios.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Definís los períodos de liquidación (por ejemplo «Enero 2026», «SAC 1er semestre») con fecha desde y hasta. Cada salario queda asociado a un período.',
      },
      {
        title: 'Lista',
        bullets: [
          'Interruptor «Solo periodos habilitados» — activo por defecto.',
          'Columnas: Descripción, Desde, Hasta, Habilitado.',
          'La casilla Habilitado en cada fila activa o desactiva el período (no hay edición de fechas desde acá).',
          'Podés exportar la lista.',
        ],
      },
      {
        title: 'Alta de período',
        intro: 'Botón +. Campos:',
        fields: [
          { label: 'Descripción', description: 'Nombre del período. Obligatoria.' },
          { label: 'Fecha de inicio / fin', description: 'Obligatorias. La fin no puede ser anterior al inicio.' },
          { label: 'Habilitado', description: 'Marcado por defecto al crear.' },
        ],
      },
      {
        title: 'Habilitar o deshabilitar',
        bullets: [
          'Al deshabilitar un período, todos sus salarios quedan deshabilitados automáticamente.',
          'Al volver a habilitar, el sistema pregunta si también querés habilitar los salarios que ya existían en ese período (Sí / No).',
        ],
      },
    ],
  },
}
